module.exports = __webpack_public_path__ + "media/images/login-a20141a9ea7c7f1dbbb2518fce8b470d.jpg";